import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const RUN_PATTERN = /^\d{1,8}[0-9kK]$/;
const RUN_FACTORS = [2, 3, 4, 5, 6, 7];

export const runValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
  const rawValue = control.value;

  if (!rawValue) {
    return null;
  }

  const value = String(rawValue).replace(/[.-]/g, '');

  if (!RUN_PATTERN.test(value)) {
    return { run: true };
  }

  const body = value.slice(0, -1);
  const checkDigit = value.slice(-1).toLowerCase();

  let sum = 0;

  for (let i = body.length - 1, factorIndex = 0; i >= 0; i--, factorIndex++) {
    sum += Number(body[i]) * RUN_FACTORS[factorIndex % RUN_FACTORS.length];
  }

  const remainder = 11 - (sum % 11);
  let expectedCheckDigit: string;
  if (remainder === 11) {
    expectedCheckDigit = '0';
  } else {
    expectedCheckDigit = remainder === 10 ? 'k' : remainder.toString();
  }

  return checkDigit === expectedCheckDigit ? null : { run: true };
};
